import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Message } from "../interfaces";

@Injectable({
	providedIn: 'root'
})
export class MessageService {
	onMessage: Subject<Message> = new Subject();
}